const ARTICLES = [
  {
    name: "Internship",
    price: 400,
    picture: "/assets/fixtures/articles/article.png",
  },
  {
    name: "Internship",
    price: 400,
    picture: "/assets/fixtures/articles/article.png",
  },
  {
    name: "Internship",
    price: 400,
    picture: "/assets/fixtures/articles/article.png",
  },
];

export default ARTICLES;
